module.exports = __webpack_public_path__ + "img/schnittkante_steingrau_ohneral.78a4af3a.jpg";